import { InvoiceDocumentType } from '@features/invoices/enums/invoiceDocumentType'

import type { InvoicingSettingsFieldPatch } from './invoicingSettingsFieldPatch'

// The only model types a module can patch fields on today. The type and the runtime guard in
// getInvoicingSettingsPayload both derive from this array, so the two can't drift apart if this
// set ever grows.
export const patchableModelTypes = [InvoiceDocumentType.Invoice, InvoiceDocumentType.Quote] as const

export type InvoicingSettingsPatchableModelType = (typeof patchableModelTypes)[number]

// Keyed by model type, so a model can only ever get one field patch from a single call — there is
// no group-merge rule to reason about, and a field listed twice can't silently lose one value.
// A module that needs the same fields on both models repeats them under each key.
export type InvoicingSettingsModelPatches = Partial<
  Record<InvoicingSettingsPatchableModelType, InvoicingSettingsFieldPatch>
>
